import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './registerServiceWorker';
import './styles/index.css';
// المرحلة 1.1's screens, after the main sheet so Tailwind's preflight cannot win a tie.
import './styles/foundation.css';
// المرحلة 1.2's: the health profile, the allergy band, the pre-visit questions.
import './styles/health.css';
// المرحلة 1.3: finding and booking a doctor, the queue, the applications.
import './styles/discovery.css';
// المرحلة 1.35: the price list, the quick reception, the child file, the booklet.
import './styles/center.css';
// المرحلة 1.4: the visit page, its papers, the patient's visits and the verify page.
import './styles/clinical.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// After the render call, not before: the worker is for the *next* visit, and
// the first one should spend its bandwidth on the screen in front of the user.
registerServiceWorker();
